import React, { useContext, useState } from "react"
import { changeCssVaribles } from "@services/changeCssVaribles";
// Constans
export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';
export const THEME_NEITRAL = 'neitral';

const ThemeContext = React.createContext();

export const ThemeProvider = ({ children, ...props }) => {
    const [theme, setTheme] = useState(null);

    const chenge = name => {
        setTheme(name);
        changeCssVaribles(name)
    }

    return (
        <ThemeContext.Provider
            value={{
                theme,
                chenge
            }}
                {...props}
        >
            {children}
        </ThemeContext.Provider>
    )
}

export default ThemeProvider;

export const useTheme = () => useContext(ThemeContext);